import { create } from "zustand"

interface PageContextState {
  pageTitle: string
  breadcrumbOverrides: Record<string, string>
  setPageTitle: (title: string) => void
  clearPageTitle: () => void
  setBreadcrumbOverride: (key: string, label: string) => void
  clearBreadcrumbOverride: (key: string) => void
}

export const usePageContext = create<PageContextState>()((set) => ({
  pageTitle: "",
  breadcrumbOverrides: {},
  setPageTitle: (title: string) => set({ pageTitle: title }),
  clearPageTitle: () => set({ pageTitle: "" }),
  setBreadcrumbOverride: (key: string, label: string) =>
    set((state) => ({
      breadcrumbOverrides: { ...state.breadcrumbOverrides, [key]: label },
    })),
  clearBreadcrumbOverride: (key: string) =>
    set((state) => {
      const { [key]: _, ...rest } = state.breadcrumbOverrides
      return { breadcrumbOverrides: rest }
    }),
}))
